module.exports = __webpack_public_path__ + "img/2-5.e6452f45.svg";